import { Acma_senderidauthorisation_statuscode, Authorisation, AuthorisationPayload, Client, Hint } from "../api";
import { ListCache } from "./ListCache";

const _cache = new ListCache<Authorisation>()

export const hintToVal = (hint?: Hint) => {
  return (t: Authorisation) => {
    switch (hint) {
      case Hint.Party:
        return t.partyName?.toLowerCase();
      case Hint.Abn:
        return t.clientABN;
      case Hint.Company:
        return t.clientName?.toLowerCase();
      case Hint.CreatedOn:
        return t.createdOn;
      case Hint.Name:
        return t.name?.toLowerCase();
      case Hint.Contact:
        return t.contactName?.toLowerCase();
      case Hint.Status:
        return t.status;
    }
  }
}

export class AuthorisationStore {
  client: Client

  constructor(client: Client) {
    this.client = client;
  }

  async getAuthorisations(abns: string[] | undefined, names: string[] | undefined, parties: string[] | undefined, contacts: string[] | undefined, statuses: Acma_senderidauthorisation_statuscode[] | undefined, search: string | undefined, sorting: Hint, sortingDesc: boolean, pageNumber: number, pageSize: number) {
    var res = await this.client.getAuthorisations(abns, names, parties, contacts, statuses, search, sorting, sortingDesc, pageNumber, pageSize);

    return _cache
      .listContains(abns, r => r.clientABN)
      .listContains(names, r => r.name)
      .listContains(parties, r => r.partyName)
      .listContains(contacts, r => r.contactEmail)
      .listContains(statuses, r => r.status)
      .containsText(search, r => r.name, r => r.partyName, r => r.contactName, r => r.contactEmail)
      .mergeServerData(res, r => r.authorisationId, pageSize, [hintToVal(sorting), sortingDesc]);
  }

  async addAuthorisations(body: AuthorisationPayload | undefined) {
    var res = await this.client.addAuthorisations(body);
    var token: string | undefined = "";
    for (var r of res) {
      token = r.token;
      delete r.token;

      if (r.authorisationId) {
        _cache.set(r.authorisationId, r);
      }
    }
    return token;
  }

  async revokeAuthorisations(ids: string[] | undefined) {
    var res = await this.client.revokeAuthorisation(ids);

    for (var r of res) {
      _cache.del(r);
    }
  }

  async approveAuthorisations(ids: string[] | undefined) {
    var res = await this.client.approveAuthorisation(ids);

    for (var r of res) {
      if (r.authorisationId) {
        _cache.set(r.authorisationId, r);
      }
    }
  }
}